import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ChevronLeft } from "@material-ui/icons";
import settings from "@styles/settings";
import React, {useContext} from "react";
import theme from "../../styles/theme";
import { TextContext } from "@pages/bepaal-statuut";

const useStyles = makeStyles({
  backButton: {
    margin: "20px",
    backgroundColor: theme.palette.primary.light,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },  
  },
});

const NavigationButtons = (props: { onBack: any; onNext: any }) => {
  const classes = useStyles();
  const text = useContext(TextContext);
  return (
    <div
      style={{
        // position: "fixed",
        // bottom: "0",
        // left: "0",
        width: "100%",
        height: settings.navigationButtonsBarHeight,
        backgroundColor: "rgb(240, 237, 237,1)",
        display: "flex",
        justifyContent: "flex-start",
        // boxShadow: theme.shadows[5],
      }}
    >
      <Button
        color="primary"
        style={{
          maxWidth: "130px",
          textAlign: "center",
        }}
        fullWidth
        className={classes.backButton}
        onClick={props.onBack}
        variant="contained"
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            paddingRight: "10px",
          }}
        >
          <ChevronLeft htmlColor={"white"} /> {text.general_button_previous}
        </div>
      </Button>
    </div>
  );
};

export default NavigationButtons;
